import { Component, inject, input, output, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SignaturePadComponent, SignaturePadOptions } from '../signature-pad/signature-pad.component';
import { SvgIconsComponent } from '../svg-icons/svg-icons.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-signature-pad-dialog',
  standalone: true,
  imports: [SignaturePadComponent, SvgIconsComponent, CommonModule],
  templateUrl: './signature-pad-dialog.component.html',
  styleUrl: './signature-pad-dialog.component.scss'
})
export class SignaturePadDialogComponent {
  @ViewChild(SignaturePadComponent) signaturePad!: SignaturePadComponent;
  // Optional: when opened via an ng-template, NgbActiveModal is not provided
  #activeModal = inject(NgbActiveModal, { optional: true });

  // Inputs
  title = input<string>('Sign Here');
  options = input<SignaturePadOptions>({});
  width = input<string>('100%');
  height = input<string>('400px');
  showDownloadButton = input<boolean>(true);
  backgroundColor = input<string>('rgb(255,255,255)');

  // Outputs
  signatureSaved = output<string>(); // Emits data URL
  signatureCleared = output<void>();

  onSignatureSaved(dataUrl: string): void {
    this.signatureSaved.emit(dataUrl);
    this.#activeModal?.close(dataUrl);
  }

  onSignatureCleared(): void {
    this.signatureCleared.emit();
  }

  onClear(): void {
    this.signaturePad.clear();
  }

  onSave(): void {
    this.signaturePad.save('image/png');
  }
  downloadSignature(): void {
    if (this.signaturePad.isEmptySignature()) {
      return;
    }
    const dataUrl = this.signaturePad.save('image/png');
    if (dataUrl) {
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = `signature-${Date.now()}.png`;
      link.click();
    }
  }

  closeDialog(): void {
    this.#activeModal?.dismiss();
  }
}
